import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import DataGrid, {DataGridItem} from "components/data-grid";
import {injectIntl} from "react-intl";
import styles from "./styles/disks-data.css.js";
import withStyles from "components/with-styles";
import {TextDisplay} from "components/display-data";
import {PageSection} from "components/page";
import Chip from "@material-ui/core/Chip";

import {DISK_STATUS_DISCONNECTED} from "../../local-records/local-records-constants";
import Typography from "@material-ui/core/Typography";

const DisksData = ({name, totalDisk, occupiedDisk, key, status, classes, intl}) => {

    return (
        <PageSection
            className={cn(classes.liveStream, {
                [classes.deleted]: status === DISK_STATUS_DISCONNECTED,
            })}
            key={key}
            subsection>
            <DataGrid className={classes.disk_container}>
                <DataGridItem>
                    <TextDisplay
                        label={intl.formatMessage({id: "common.name"})}
                        className={cn(classes.data, {
                            [classes.deleted__text]: status === DISK_STATUS_DISCONNECTED,
                        })}
                        classNameLabel={cn({
                            [classes.deleted__text]: status === DISK_STATUS_DISCONNECTED,
                        })}
                    >
                        <span>{name}</span>
                    </TextDisplay>
                </DataGridItem>
                <DataGridItem>
                    <TextDisplay
                        label={intl.formatMessage({id: "common.occupied"})}
                        className={cn(classes.data, {
                            [classes.deleted__text]: status === DISK_STATUS_DISCONNECTED,
                        })}
                        classNameLabel={cn({
                            [classes.deleted__text]: status === DISK_STATUS_DISCONNECTED,
                        })}>
                        <div>
                            <span>{+totalDisk === 0 ? '--%' : ((occupiedDisk / totalDisk) * 100).toFixed(2) + ' %'}</span>
                        </div>
                        <Typography variant={"caption"}>{`${occupiedDisk} / ${totalDisk}`}</Typography>
                    </TextDisplay>
                </DataGridItem>

                <DataGridItem className={classes.disk_status_container}>
                    <Chip
                        className={cn(classes.disk__status, {
                            [classes.deleted__text]: status === DISK_STATUS_DISCONNECTED,
                            [classes.deleted__status]: status === DISK_STATUS_DISCONNECTED,
                        })}
                        variant="outlined"
                        label={intl.formatMessage({id: `source.disk.status.in.${status}`})}
                    />
                </DataGridItem>


            </DataGrid>
        </PageSection>
    );
};

DisksData.propTypes = {
    name: PropTypes.string.isRequired,
    totalDisk: PropTypes.any,
    occupiedDisk: PropTypes.any,
    key: PropTypes.number, status: PropTypes.string
};

export default withStyles(styles)(injectIntl(DisksData));
